export default __webpack_public_path__ + "static/media/Group1027.7533e9fa.svg";